import Information from '@/components/admin/user/Information';
import React from 'react';

const UserInformation = () => {
  return <Information />;
};

export default UserInformation;
